export default __webpack_public_path__ + "static/plx-bl-71ddb2801bf31871b25e90f9fdbf1bf4.jpg";